import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import { tracked } from "@glimmer/tracking";

export default class LoadBalancerListenerModel extends Model {
  @attr backend;
  @attr mode;
  @attr name;
  @attr port;
  @attr status;
  @attr("yesno") stickysessions;
  @attr sslcertificate;
  @attr("number") maxconnections;
  @attr("milliseconds-as-seconds") clienttimeout;
  @attr("milliseconds-as-seconds") connecttimeout;
  @attr("milliseconds-as-seconds") responsetimeout;

  @belongsTo("load-balancer", { async: false, inverse: "listeners" }) loadBalancer;
  @hasMany("load-balancer-target", { async: false, inverse: "listener" }) targets;

  @tracked metrics;

  get dirtyTargets() {
    return this.hasMany("targets")
      .value()
      ?.filter((target) => target.isDirty);
  }

  get hasDirtyTargets() {
    return this.dirtyTargets?.length > 0;
  }

  get isDirty() {
    return this.hasDirtyAttributes || this.isDeleted || this.hasDirtyTargets;
  }
}
